import { SessionService } from '../sessions/session.service';

import DvlaLookupSettingsHtml from './dvla-lookup.settings.html';

export function DVLALookupStates (
  $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'DVLALookupSettingsCtrl',
    name       : 'app.dvla-lookup',
    templateUrl: DvlaLookupSettingsHtml,
    url        : '/dvla_lookup',
    resolve    : {
      refresh: ( sessionObjAPI : SessionService ) : ng.IPromise<any> => sessionObjAPI.refresh()
    }
  });
}